import script from "./DialogPump.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogPump.vue?vue&type=script&setup=true&lang=ts"

import "./DialogPump.vue?vue&type=style&index=0&id=38bf6dff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38bf6dff"]])

export default __exports__